import { cancelRequest } from "@core/api-setup";

import { looseEqual } from "../utils";

export default {
  data: () => ({
    loading: false,
    items: [],
    collapsed: true,
    filters: {},
    totalItems: 0,
    isCachingFilters: true,
    queryCounter: 0,
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 10,
      sortBy: null,
      totalItems: 0
    },
    useCacheFilters: true
  }),

  mounted() {
    this.fetchData(this.pagination.page, this.activeFilters());
  },

  beforeRouteUpdate(to, from, next) {
    this.pagination.page = parseInt(to.query.page) || 1;
    this.pagination.rowsPerPage = parseInt(to.query.limit) || 10;

    this.queryCounter = parseInt(to.query.c) || 0;
    this.queryCounter = this.queryCounter < 10 ? this.queryCounter + 1 : 1;

    if (this.isCachingFilters) {
      this.filters = Object.assign({}, to.query);
    }

    this.fetchData(this.pagination.page, this.activeFilters());
    next();
  },

  beforeRouteLeave(to, from, next) {
    cancelRequest("pagination");
    next();
  },

  beforeMount() {
    this.pagination.page = parseInt(this.$route.query.page) || 1;
    this.pagination.rowsPerPage = parseInt(this.$route.query.limit) || 10;

    this.queryCounter = parseInt(this.$route.query.c) || 0;
    this.queryCounter = this.queryCounter < 10 ? this.queryCounter + 1 : 1;

    if (this.isCachingFilters) {
      this.filters = Object.assign({}, this.$route.query);
    }
  },

  watch: {
    pagination: {
      deep: true,
      handler(newValue, oldValue) {
        if (!looseEqual(this.pagination, oldValue)) {
          this.filters.page = this.pagination.page;
          this.filters.limit = this.pagination.rowsPerPage;

          if (this.isCachingFilters) {
            this.$router.push({
              name: this.$route.name,
              query: this.activeFilters()
            });
          } else {
            this.fetchData(this.pagination.page, this.activeFilters());
          }
        }
      }
    }
  },

  methods: {
    resetItems() {
      console.warn(
        "Error: Mixin reset item executed. Please add this method on the component and implement the mutation"
      );
    },

    fetchData(page, filters = {}) {
      console.warn(
        "Error: Mixin reset item executed. Please add this method on the component and implement the action"
      );
    },

    clearFilters() {
      if (typeof this.$options.data !== "undefined") {
        Object.assign(this.$data, this.$options.data.apply(this), {
          collapsed: this.collapsed,
          queryCounter: this.queryCounter
        });
      }

      this.filter();
    },

    activeFilters() {
      const _filters = {};
      let value;

      for (var key in this.filters) {
        value = this.filters[key];

        if ((typeof value == "string" && value.length == 0) || value == null) {
          continue;
        } else if (typeof value == "boolean") {
          value = value ? 1 : 0;
        }

        _filters[key] = value;
      }

      _filters.c = this.queryCounter;
      _filters.pagination = 1;
      _filters.page = this.pagination.page || 1;
      _filters.limit = this.pagination.rowsPerPage;

      return _filters;
    },

    filter() {
      this.pagination.page = 1;

      if (this.isCachingFilters && this.useCacheFilters) {
        this.$router.push({
          name: this.$route.name,
          query: this.activeFilters()
        });
      } else {
        console.log("fetchData", 1, this.activeFilters());
        this.fetchData(1, this.activeFilters());
      }
    }
  }
};
